import { JobStatus } from "Infrastructure/Api/Api";

export const isJobLocked = (status: JobStatus): boolean =>
  status === JobStatus.WaitingForApproval || status === JobStatus.Done;
